var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-15 mt-15" }, [_vm._v("No service added")]),
    _vm._m(0),
    _c("div", { staticClass: "center" }, [
      _vm._v(" Checkout the "),
      _c(
        "a",
        {
          staticClass: "cursor-pointer",
          attrs: { "data-dismiss": "modal" },
          on: {
            click: function ($event) {
              return _vm.redirect("/layout/market-place")
            },
          },
        },
        [_vm._v("Marketplace")]
      ),
      _vm._v(" to browse our services. "),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "center" }, [
      _c("img", {
        staticClass: "market_place_img",
        attrs: {
          src: "/static/images/icons/marketplace.svg",
          alt: "market-imgs",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }